<div class="unauth-right-header">
  <img src="assets/images/complydome-logo.png" class="unauth-mobile-logo" alt="ComplyDome">
  <a routerLink="/login">← Back to Sign In</a>
</div>

<main class="unauth-form-area">
  <div class="unauth-card">
    <h2>Verify Your Identity</h2>

    <div class="unauth-security-badge">
      <span class="unauth-security-dot"></span>
      Two-Factor Authentication
    </div>

    <p class="unauth-mfa-hint">
      We sent a 6-digit code to <strong>{{ maskedEmail }}</strong>. Enter it below to continue.
    </p>

    <form [formGroup]="mfaForm" (ngSubmit)="onSubmit()" autocomplete="off" novalidate>

      <input type="hidden" formControlName="token" [value]="token">

      <div class="unauth-otp-group">
        <input type="tel" id="digit1" formControlName="digit1" maxlength="1"
          class="unauth-otp-input" autofocus (keydown)="onKeydown($event, 1)" aria-label="Digit 1">
        <input type="tel" id="digit2" formControlName="digit2" maxlength="1"
          class="unauth-otp-input" (keydown)="onKeydown($event, 2)" aria-label="Digit 2">
        <input type="tel" id="digit3" formControlName="digit3" maxlength="1"
          class="unauth-otp-input" (keydown)="onKeydown($event, 3)" aria-label="Digit 3">
        <input type="tel" id="digit4" formControlName="digit4" maxlength="1"
          class="unauth-otp-input" (keydown)="onKeydown($event, 4)" aria-label="Digit 4">
        <input type="tel" id="digit5" formControlName="digit5" maxlength="1"
          class="unauth-otp-input" (keydown)="onKeydown($event, 5)" aria-label="Digit 5">
        <input type="tel" id="digit6" formControlName="digit6" maxlength="1"
          class="unauth-otp-input" (keydown)="onKeydown($event, 6)" aria-label="Digit 6">
      </div>

      <button
        type="submit"
        class="unauth-btn-primary"
        [disabled]="!mfaForm.valid || isLoading">
        <span class="unauth-spinner" *ngIf="isLoading"></span>
        <span *ngIf="!isLoading">Verify</span>
      </button>

      <div class="unauth-forgot">
        <a routerLink="/login">Back to Sign In</a>
      </div>

    </form>
  </div>
</main>
